import _, { isInteger } from 'lodash';
import moment from 'moment';
import DATE_FORMATS from '../constants/dateFormats';

export function date(row, format = DATE_FORMATS.date) {
  if (!row.value) {
    return null;
  }

  const momentDate = moment(row.value);

  if (!momentDate.isValid()) {
    return row.value;
  }

  return momentDate.format(DATE_FORMATS.date);
}

export function dateWithDay(row, format = DATE_FORMATS.dateWithDayName) {
  if (!row.value) {
    return null;
  }

  const momentDate = moment(row.value);

  if (!momentDate.isValid()) {
    return row.value;
  }

  return momentDate.format(DATE_FORMATS.dateWithDayName);
}

export function dateTime(row, format = DATE_FORMATS.dateTime) {
  if (!row.value) {
    return null;
  }

  const momentDate = moment(row.value);

  if (!momentDate.isValid()) {
    return row.value;
  }

  return momentDate.format(DATE_FORMATS.dateTime);
}

export function dateTimeWithSeconds(row, format = DATE_FORMATS.dateTimeWithSeconds) {
  if (!row.value) {
    return null;
  }

  const momentDate = moment(row.value);

  if (!momentDate.isValid()) {
    return row.value;
  }

  return momentDate.format(DATE_FORMATS.dateTimeWithSeconds);
}

export function percentage(row) {
  const percentageValue = row.value;

  if ((!percentageValue || Number.isNaN(Number(percentageValue))) && percentageValue !== 0) {
    return row.value;
  }

  const roundedPercentageValue = (Math.round(percentageValue * 10) / 10).toFixed(1);

  return `${roundedPercentageValue} %`;
}

export function number(row) {
  let returnValue;
  if (!isInteger(row.value)) {
    returnValue = (typeof row.value === 'undefined' || row.value === null) ? '' : Math.round(row.value).toString();
  } else {
    returnValue = (typeof row.value === 'undefined' || row.value === null) ? '' : row.value.toString();
  }
  return returnValue;
}

export function float(row) {
  if (typeof row.value === 'undefined' || row.value === null) {
    return '';
  }
  const numberString = number(row);
  return numberString.indexOf('.') >= 0 ? numberString : `${numberString}.0`;
}

export function boolean(row) {
  return row.value === true ? 'Yes' : 'No';
}

export function duration(row) {
  const hours = parseInt(_.first(row.value.split(':')), 10);
  const minutes = parseInt(_.last(row.value.split(':')), 10);

  return `${(`${hours}`).padStart(2, '0')}:${(`${minutes}`).padStart(2, '0')}`;
}

export function nonZeroNumber(row) {
  return row && row.value ? number(row) : '';
}

export function nonZeroPercentage(row) {
  return row && row.value ? percentage(row) : '';
}

export function nonZeroFloat(row) {
  return row && row.value ? float(row) : '';
}

export function nonZeroText(row) {
  return row && row.value && row.value !== '0' ? row.value.toString() : '';
}

export function commaText(row) {
  return row && row.value && row.value !== '0' ? row.value.join(', ') : '';
}

export const formatMap = {
  date,
  dateWithDay,
  dateTime,
  dateTimeWithSeconds,
  float,
  percentage,
  boolean,
  number,
  duration,
  nonZeroNumber,
  nonZeroPercentage,
  nonZeroFloat,
  nonZeroText,
  commaText,
};

export default function formatField(fieldType) {
  return formatMap[fieldType];
}
